import _deburr from 'lodash/deburr';

const normalizeSearchText = (text: string) => {
  return _deburr(text.normalize('NFKD').toLowerCase())
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201c\u201d]/g, '"')
    .replace(/[\u2010-\u2015\u2212]/g, '-');
};

export const getSearchWords = (search: string) => {
  return normalizeSearchText(search).split(/\s+/).filter(Boolean);
};

export const matchesSearchWords = (text: string, searchWords: string[]) => {
  if (searchWords.length === 0) {
    return true;
  }

  const normalizedText = normalizeSearchText(text);
  return searchWords.every((word) => {
    return normalizedText.includes(word);
  });
};
